export default {
  homeData: null,
  suggestKeywords: null,
};
